import React from "react";
import { HeroSection as SharedHeroSection } from "@/components/design-system/HeroSection/HeroSection";
import { URLS } from "@/data/constants";
import { trackCalendlyClick } from "@/utils/analytics";

export const HeroSection: React.FC = () => {
  const handleCalendlyClick = () => {
    trackCalendlyClick("hero");
    window.open(URLS.CALENDLY, "_blank");
  };

  return (
    <SharedHeroSection
      headline="The organizations winning with AI aren't waiting."
      description="Bravo powers personalized financial guidance for your users while uncovering the signals that drive engagement, discovery, and growth for your organization."
      primaryCta={{ label: "Book a demo", onClick: handleCalendlyClick }}
      backgroundImage="/home-hero-image.jpg"
      imageClassName="absolute inset-y-0 left-[28%] h-full w-[82%] object-cover object-left"
    />
  );
};
